import { ColorV2 } from "config/colors";
import styled from "styled-components";

export const Layout = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0;
  padding: 20px;
  box-sizing: border-box;
`;

export const SummaryStrip = styled.div`
  display: flex;
  align-items: stretch;
  gap: 16px;
  margin-top: 20px;
  padding: 14px 16px;
  border-radius: 20px;
  background: ${ColorV2.White};
  overflow-x: auto;
`;

export const PeriodSlot = styled.div`
  display: flex;
  align-items: center;
  min-width: 250px;
`;
